<div [formGroup]="identityDocumentGroup" class="flex flex-col">
  <mat-form-field appearance="outline">
    <mat-label translate="">Identity document</mat-label>
    <mat-select formControlName="type">
      <mat-option [value]="null"><span translate="">None</span></mat-option>
      <mat-option [value]="'DutchPassport'"><span translate="">DutchPassport</span></mat-option>
      <mat-option [value]="'DutchIdentityCard'"><span translate="">DutchIdentityCard</span></mat-option>
      <mat-option [value]="'DutchAliensDocument'"><span translate="">DutchAliensDocument</span></mat-option>
      <mat-option [value]="'DutchAliensIdentityCard'"><span translate="">DutchAliensIdentityCard</span></mat-option>
      <mat-option [value]="'PassportCountryOfOrigin'"><span translate="">PassportCountryOfOrigin</span></mat-option>
      <mat-option [value]="'IdentityCardEuOrEaaMemberStateOrSwitzerlandWithPhoto'"><span translate="">IdentityCardEuOrEaaMemberStateOrSwitzerlandWithPhoto</span></mat-option>
      <mat-option [value]="'AlienDocumentEuOrEaaMemberState'"><span translate="">AlienDocumentEuOrEaaMemberState</span>
    </mat-option>
  </mat-select>
</mat-form-field>
@if (identityDocumentGroup.get('type')?.value && identityDocumentGroup.get('type')?.value != null) {
  <mat-form-field appearance="outline">
    <mat-label translate="">Document number</mat-label>
    <input matInput="" type="text" formControlName="number" autocomplete="off">
  </mat-form-field>
}
</div>